module.exports = __webpack_public_path__ + "img/service2.9d156583.png";